import React, { Suspense } from 'react';
import { ErrorBoundary } from './ErrorBoundary';
import { PageSkeleton } from './Skeletons';
export const RouteBoundary = ({ element, fallback }) => {
    const fallbackNode = fallback !== null && fallback !== void 0 ? fallback : React.createElement(PageSkeleton, null);
    return (React.createElement(ErrorBoundary, { fallback: fallbackNode },
        React.createElement(Suspense, { fallback: fallbackNode }, element)));
};
